import React, { createContext, useContext, useMemo } from "react";
import { useU2000AuthContext } from "../../../u2000Core/context/auth/U2000UseAuthContext";
import { useU2000TimesheetWeekView, type U2000TimesheetWeekView } from "../../../u2000Core/hooks/useU2000TimesheetWeekView";
import { NS } from "../../U3129";

const U3129TimesheetWeekViewContext = createContext<U2000TimesheetWeekView | null>(null);

type U3129TimesheetWeekViewProviderProps = {
  periodDate: string | undefined | null;
  children: React.ReactNode;
};

export function U3129TimesheetWeekViewProvider({ periodDate, children }: U3129TimesheetWeekViewProviderProps) {
  const { auth } = useU2000AuthContext();
  const weekendToggleStorageKey = useMemo(
    () =>
      auth.isAuthenticated && auth.user.userName
        ? `U3129_${auth.user.userName}_${auth.user.organizationId || "noorg"}ShowWeekendDays`
        : "U3129ShowWeekendDays",
    [auth.isAuthenticated, auth.user.organizationId, auth.user.userName],
  );
  const weekView = useU2000TimesheetWeekView(periodDate, NS, weekendToggleStorageKey);
  return <U3129TimesheetWeekViewContext.Provider value={weekView}>{children}</U3129TimesheetWeekViewContext.Provider>;
}

export function useU3129TimesheetWeekView(): U2000TimesheetWeekView {
  const value = useContext(U3129TimesheetWeekViewContext);
  if (value == null) {
    throw new Error("useU3129TimesheetWeekView doit être utilisé sous U3129TimesheetWeekViewProvider");
  }
  return value;
}
